import React, { use, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import allTeams from "../../data/teams"; 

interface Team {
    id: number,
    franchiseId: number,
    fullName: string,
    leagueId: number,
    rawTricode: string,
    triCode: string,
    colors : string[],
    conference: string,
    division: string,
  }

const PointPerPlayer = ({ game, homeTeam, awayTeam }) => {
    const gamePlays = game?.plays || [];
    const homeTeamId = homeTeam.id;
    const awayTeamId = awayTeam.id;
    const roster = game?.rosterSpots || [];
    const [homeTeamColor, setHomeTeamColor] = useState<string[]>([]);
    const [awayTeamColor, setAwayTeamColor] = useState<string[]>([]);
    const homeTeamPlayersPoints: Array<{ div: React.ReactElement; points: number }> = [];
    const awayTeamPlayersPoints: Array<{ div: React.ReactElement; points: number }> = [];

    roster.forEach((player) => {
        let goal = 0;
        let assist = 0;
        const playerPlays = gamePlays.filter(
            (play) =>
                play.typeDescKey === "goal" &&
                (
                    play.details.scoringPlayerId === player.playerId ||
                    play.details.assist1PlayerId === player.playerId ||
                    play.details.assist2PlayerId === player.playerId
                )
        );
        playerPlays.forEach(play => {
            if (play.details.scoringPlayerId === player.playerId) {
                goal++;
            }
            if (
                play.details.assist1PlayerId === player.playerId ||
                play.details.assist2PlayerId === player.playerId
            ) {
                assist++;
            }
        });
    
        const points = goal + assist;
        const playerDiv = (
            <div key={player.playerId} className="contentpts">
                <div><Link to={`/player/${player.playerId}`}><b>{player.firstName.default} {player.lastName.default}</b></Link></div> <div>{goal > 0 && <b>{goal}</b>}</div> <div>{assist > 0 && <b>{assist}</b>}</div>
            </div>
        );
    
        if (player.teamId === homeTeamId && points > 0) {
            homeTeamPlayersPoints.push({ div: playerDiv, points });
        } else if (player.teamId === awayTeamId && points > 0) {
            awayTeamPlayersPoints.push({ div: playerDiv, points });
        }
    });
    
    // Sort by points descending
    homeTeamPlayersPoints.sort((a, b) => b.points - a.points);
    awayTeamPlayersPoints.sort((a, b) => b.points - a.points);
    
    const getTeamColor = (teamId: number, allTeams: Team[]) => {
        const team = allTeams.find((team) => team.id === teamId);
        return team ? team.colors : null; // Return the color if the team is found, otherwise return null
      };

    useEffect(() => {

        const safeHomeTeamColor: string[] = getTeamColor(homeTeam.id, allTeams) || ["#FFFFFF"]; // Default to black
        setHomeTeamColor(safeHomeTeamColor);
        const safeAwayTeamColor: string[] = getTeamColor(awayTeam.id, allTeams) || ["#FFFFF"]; // Default to black
        setAwayTeamColor(safeAwayTeamColor);

    }, [game, homeTeam, awayTeam]);

    return (
        <div className="pointPerPlayer">
            <div className="wrapperpts" style={{ background: `linear-gradient(110deg, ${homeTeamColor[0]} 80%,  ${homeTeamColor[1]} 80%,  ${homeTeamColor[1]} 82%, ${homeTeamColor[2]} 82%)`}}>
                <div className="titlepts">
                <div><h2>{game?.homeTeam?.commonName?.default}</h2></div>
                <div>G</div>
                <div>A</div>
                </div>
                {homeTeamPlayersPoints.map(item => item.div)}
            </div>
            <div className="wrapperpts" style={{ background: `linear-gradient(110deg, ${awayTeamColor[0]} 80%,  ${awayTeamColor[1]} 80%,  ${awayTeamColor[1]} 82%, ${awayTeamColor[2]} 82%)`}}>
                <div className="titlepts">
                <div>
                <h2>{game?.awayTeam?.commonName?.default}</h2>
                </div>
                <div>G</div>
                <div>A</div>
                </div>
                {awayTeamPlayersPoints.map(item => item.div)}
            </div>
        </div>
    );
};

export default PointPerPlayer;